<template>

  <div class="col"></div>
  <div class="col text-center"><button class="btn btn-primary" @click="gotoICarRTS()">Go to I-Car RTS</button>
  </div>
  <div class="col"></div>

  <!-- <iframe :src="rtsICarLink" style="width: 100%; height: 100vh; border: none;" title="RTS I-Car"></iframe> -->
</template>
<script>
export default {
  name: "ICarRTS",
  props: {
    make: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rtsICarLink: 'https://rts.i-car.com/search-by-vehicle.html'
    }
  },
  methods: {
    gotoICarRTS() {
      const link = this.rtsICarLink
      if (link) {
        window.open(link, '_blank')
      } else {
        console.error('No valid I-Car RTS link found for make:', this.make)
      }
    }
  },
}
</script>
<style lang="scss" scoped></style>